import { Action } from '@ngrx/store';
import { FollowGroup } from '@app/models/follow-group';

export enum FollowGroupActionTypes {
  Load = '[FollowGroup] Load',
  LoadSuccess = '[FollowGroup] Load Success',
  LoadFail = '[FollowGroup] Load Fail',
  Filter = '[FollowGroup] Add Filter',
  FilterClear = '[FollowGroup] Clear Filter'
}

export class Load implements Action {
  readonly type = FollowGroupActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = FollowGroupActionTypes.LoadSuccess;
  constructor(public followGroups: FollowGroup[]) {}
}

export class LoadFail implements Action {
  readonly type = FollowGroupActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Filter implements Action {
  readonly type = FollowGroupActionTypes.Filter;
  constructor(public key: any) {}
}

export class FilterClear implements Action {
  readonly type = FollowGroupActionTypes.FilterClear;
  constructor(public key: any) {}
}

export type FollowGroupActionsUnion = 
Load | 
LoadSuccess | 
LoadFail |
Filter |
FilterClear;
